module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8OJQw"))).then(() => parcelRequire('lzHZl'));